export interface GenerateAndDownloadQuotationAnalysisFormPDFDto {
	includeChildren: boolean;
	quotationAnalysisFormId: number;
}

export class GenerateAndDownloadQuotationAnalysisFormPDFDto implements GenerateAndDownloadQuotationAnalysisFormPDFDto {	
	constructor(data?: Partial<GenerateAndDownloadQuotationAnalysisFormPDFDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}